import { useEffect, useState } from "react";

const MESSAGES = [
  "Complimentary shipping worldwide",
  "Made to order in Antwerp",
  "30-day returns on unworn pieces",
];

export default function Announcement() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 4200);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="announce fixed top-0 left-0 right-0 z-[55]" role="region" aria-label="Announcements">
      {MESSAGES.map((m, i) => (
        <span key={m} className={`announce-msg ${i === idx ? "is-active" : ""}`}>{m}</span>
      ))}
    </div>
  );
}